import { put, call, select, takeEvery } from 'redux-saga/effects'
import { ERROR, ERROR_CLOSED, MESSAGE_TYPES, REFRESH_FREEROUNDS } from '../constants'
import { message, setPlayingRequest, jackpotMessageClosed, goToLobby } from '../actions'

let unloading = false
window.addEventListener('beforeunload', () => {
  unloading = true
})

/**
 * This creates listeners for different events, and connects sagas that
 * will run when that event is received.
 */
export default function* watchErrorFetchData() {
  yield takeEvery(ERROR, handleError)
  yield takeEvery(ERROR_CLOSED, onErrorClosed)
}

/**
 * Saga that handles any errors received on ERROR event.
 * @param {object} action - Object containing error information.
 */
function* handleError(action) {
  const { error } = action

  // eslint-disable-next-line no-console
  console.warn(`${error.errorMessage} code: ${error.errorCode}`)

  switch (error.errorCode) {
    case 538: { // Jackpot has been won
      yield put(message({
        type: MESSAGE_TYPES.JACKPOT,
        data: error,
        onClose: jackpotMessageClosed,
      }))
      break
    }
    case 400: // Request timed out
    case 404: { // Request timed out
      yield call(showError, error)
      yield put(setPlayingRequest(false))
      break
    }
    case 503: // Session missing or expired
    case 520: // Session moved to other browser
      yield call(reLogin, error)
      break
    case 527: {
      yield put({ type: REFRESH_FREEROUNDS })
      break
    }
    default:
      yield call(showError, error)
      break
  }
}

/**
 * Saga triggered when an error message is closed.
 * @param {object} action - Object containing error information.
 */
function* onErrorClosed(action) {
  const { error } = action
  if (error) {
    switch (error.errorCode) {
      case 101:
      case 519: {
        yield put(goToLobby())
        break
      }
      default: {
        break
      }
    }
  }
}

/**
 * Saga that dispatches a message on errors.
 * @param {object} error - Object containing information about the error.
 * @param {string} title - DEPRACATED. No longer used.
 */
function* showError(error, title) {
  const { loading, externalErrorHandling } = yield select(state => state.base)

  if (unloading) {
    return
  }

  if (loading && !externalErrorHandling) {
    alert(`${error.errorMessage}\n code: ${error.errorCode}`)
    error.onClose && error.onClose()
    return
  }

  yield put(message({
    type: MESSAGE_TYPES.ERROR,
    message: error.errorMessage,
    ...error,
    title
  }))
}

/**
 * Saga that dispatches a message, that forces the user to login again.
 * @param {object} error - Object containing error information.
 */
function* reLogin(error) {
  const messages = yield select(state => state.base.messages)

  const found = messages.find(a => a.type === MESSAGE_TYPES.MESSAGE_LOGIN &&
      a.message === error.errorMessage)

  if (found) {
    return
  }

  yield put(message({
    type: MESSAGE_TYPES.MESSAGE_LOGIN,
    message: error.errorMessage,
    ...error,
    noCloseButton: true
  }))
}
